import EditorWithAdditionalActions from "./editorWithAdditionalActions";
import InternalEditor from "./internalEditor";

const Editor = InternalEditor;
Editor.WithAdditionalActions = EditorWithAdditionalActions;

export default Editor;